import { BookingAgencySuccessModalContent } from './BookingAgencySuccessModalContent';

export const BookingAgencySuccessModal = (): JSX.Element => (<BookingAgencySuccessModalContent />);
